module.exports = __webpack_public_path__ + "img/timer.910ec7b6.png";